'use strict';

(function (angular) {

    angular.module('zp.news').service('newsService', newsService);

    /**ngInject */
    function newsService(zpData, zpAPI, NewsModel, VenueModel, config) {

        var service = this;

        service.getLatest = getLatest;
        service.getVenues = getVenues;

        //////////////////////////////////////

        function getLatest() {
            return zpData.http({
                url: '/latest.news.json',
                method: 'GET'
            }).then(function (response) {
                var result = [];
                for (var i = 0; i < response.length; i++) {
                    result.push(new NewsModel(response[i]));
                }
                return result;
            });
        }

        function getVenues() {
            return zpAPI.http({
                url: config.zpAPI.defaultRoutes.VENUES,
                method: 'GET'
            }).then(function (response) {
                var result = [];
                for (var i = 0; i < response.length; i++) {
                    result.push(new VenueModel(response[i]));
                }
                return result;
            });
        }
    }
})(window.angular);